const themeLight = () => {
  const json = window?.config?.REACT_APP_JSON_THEMELIGHT;
  return json ? JSON.parse(json) : null;
};
const themeDark = () => {
  const json = window?.config?.REACT_APP_JSON_THEMEDARK;
  return json ? JSON.parse(json) : null;
};

export { themeLight, themeDark };
